<template>
  <slot></slot>
</template>
<script setup lang="ts">
// Definition for provider callback function signature
type ProviderWrapperProps = {
  provider?: () => void;
};

const { provider = () => {} } = defineProps<ProviderWrapperProps>();

// call provider in setup
provider();
</script>
